export default __webpack_public_path__ + "static/media/pho-bo-ga.105e0c9b.jpg";